/* T8 Announcement — one item at a time: every few seconds the current item slides up and out while the next one
   slides up into place. Pauses on hover / focus; the theme editor shows the selected block. */
(function () {
  'use strict';
  function init(root) {
    (root || document).querySelectorAll('[data-t8-announce]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var items = Array.prototype.slice.call(bar.querySelectorAll('[data-t8-announce-item]'));
      if (items.length < 2) return;
      var i = 0, timer = null, paused = false;
      var wait = Math.max(2, Number(bar.dataset.interval) || 4) * 1000;

      function go(next) {
        if (next === i) return;
        var cur = items[i], nxt = items[next];
        cur.classList.remove('is-active'); cur.classList.add('is-leaving'); cur.setAttribute('aria-hidden', 'true');
        nxt.classList.remove('is-leaving'); nxt.classList.add('is-active'); nxt.removeAttribute('aria-hidden');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 700);   // back below, out of sight, ready for its next turn
        i = next;
      }
      function tick() { if (!paused && !document.hidden) go((i + 1) % items.length); }
      function start() { stop(); timer = setInterval(tick, wait); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
      document.addEventListener('shopify:block:select', function (e) {
        var k = items.indexOf(e.target.closest('[data-t8-announce-item]')); if (k > -1) { stop(); go(k); }
      });
      document.addEventListener('shopify:block:deselect', function () { start(); });
      bar.querySelectorAll('[data-t8-copy-code]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var code = b.dataset.t8CopyCode, label = b.querySelector('[data-t8-copy-label]');
          var done = function () { b.classList.add('is-copied'); if (label) label.textContent = 'Copied'; setTimeout(function () { b.classList.remove('is-copied'); if (label) label.textContent = 'Copy'; }, 1800); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
          else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (x) {} t.remove(); done(); }
        });
      });
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
